import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

import DashboardIcon from '@mui/icons-material/Dashboard';
import BusinessIcon from '@mui/icons-material/Business';
import ReviewsIcon from '@mui/icons-material/Reviews';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';

import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import UserContext from '../../navigation/context/userContext';
import { useTranslation } from 'react-i18next';

export default function MainListItems({ onItemClick }) {
    const { t } = useTranslation();
    const { userData } = useContext(UserContext);
    const history = useHistory();
    const location = useLocation(); 
    const theme = useTheme();


    const redireccionar = (ruta) => {
        history.push(ruta);
        // 2. Ejecutamos la función para cerrar el menú si existe
        if (onItemClick) {
            onItemClick();
        }
    };

    const MenuItemCustom = ({ route, icon: Icon, text }) => {
        const isActive = location.pathname === route;

        return (
            <ListItem disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                    onClick={() => redireccionar(route)}
                    sx={{
                        borderRadius: 3, // Botones más curvos (Píldoras)
                        minHeight: 46,
                        // Fondo azul muy claro estilo GetBites
                        backgroundColor: isActive ? '#e3f2fd' : 'transparent',
                        color: isActive ? theme.palette.primary.main : '#555',
                        '&:hover': {
                            backgroundColor: isActive ? '#e3f2fd' : '#f5f5f5',
                        },
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: 40,
                            color: isActive ? theme.palette.primary.main : '#888',
                        }}
                    >
                        <Icon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText 
                        primary={text} 
                        primaryTypographyProps={{ 
                            fontWeight: isActive ? 700 : 500, // Bold si está activo
                            fontSize: '0.95rem'
                        }} 
                    />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <>            
            <MenuItemCustom route="/" icon={DashboardIcon} text={t('merchantPanel.menuOptions.home')} />
            <MenuItemCustom route="/profile" icon={BusinessIcon} text={t('merchantPanel.menuOptions.business')} />
            <MenuItemCustom route="/reviews" icon={ReviewsIcon} text={t('merchantPanel.menuOptions.reviews')} />
            <MenuItemCustom route="/employees" icon={ContactEmergencyIcon} text={t('merchantPanel.menuOptions.team')} />
            
        </>
    );    
}